// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-tooltip-root[data-v-3476c3de],\r\n.custom-tooltip-trigger[data-v-3476c3de],\r\n.custom-tooltip-trigger-button[data-v-3476c3de] {\r\n  position: static !important;\n}\n.custom-tooltip-trigger-icon[data-v-3476c3de] path {\r\n  fill: #a8a29e !important;\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
